import React from "react";
import { useTranslation } from "react-i18next";
import { YesNoQuestion as YesNoQuestionType } from "@shared/types";
import { BaseControlQuestionProps } from "./type";
import { Question } from "../question";
import { ControlledYesNoButton } from "../form/controlled-yes-no-button";

export const YesNoQuestion: React.FC<
  BaseControlQuestionProps & Omit<YesNoQuestionType, "type" | "required">
> = ({ position, id, control, question, required }) => {
  const { i18n } = useTranslation();

  return (
    <Question
      id={id}
      question={<span>{question[i18n.language]}</span>}
      position={position}
    >
      <ControlledYesNoButton name={id} control={control} rules={{ required }} />
    </Question>
  );
};
